export default function SvgUserSuspendIcon(props) {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="4" y="4" width="48" height="48" rx="24" fill="#F04438" />
      <path
        d="M32.5 20L37.5 25M37.5 20L32.5 25M32 37V35.8C32 34.1198 32 33.2798 31.673 32.638C31.3854 32.0735 30.9265 31.6146 30.362 31.327C29.7202 31 28.8802 31 27.2 31H22.8C21.1198 31 20.2798 31 19.638 31.327C19.0735 31.6146 18.6146 32.0735 18.327 32.638C18 33.2798 18 34.1198 18 35.8V37M28.5 23.5C28.5 25.433 26.933 27 25 27C23.067 27 21.5 25.433 21.5 23.5C21.5 21.567 23.067 20 25 20C26.933 20 28.5 21.567 28.5 23.5Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="4"
        y="4"
        width="48"
        height="48"
        rx="24"
        stroke="#FEE4E2"
        strokeWidth="8"
      />
    </svg>
  )
}
